module.exports = __webpack_public_path__ + "static/media/i5.958700df.png";